import React, { PureComponent } from 'react';
import cx from 'classnames';
import withStyles from '@mui/styles/withStyles';
import { getValidationDecorations } from '../../util/validation';

class ValidationPlaceholder extends PureComponent {
    render() {
        const { children, classes, className } = this.props;
        const decorations = getValidationDecorations(this.props, classes.root);
        const omitMe = !decorations.inError;
        return (
            <div className={cx(decorations.rootClass, className, omitMe && classes.omitted)}>
                {children && <div className={cx(classes.content, omitMe && classes.omitted)}>{children}</div>}
                <div className={cx(decorations.validationLabel, omitMe && classes.omitted)}>{decorations.errorMsg}</div>
            </div>
        );
    }
}

const styles = ({ spacing, palette }) => ({
    content: {
        //child content
        margin: '1px 10px 0 10px',
        display: 'flex',
        flexWrap: 'wrap',
        // reinstate Grid padding
        '&>div:not(first-child)': { paddingTop: spacing(1) },
        '&>div:not(last-child)': { paddingBottom: spacing(1) }
    },
    root: {
        margin: '-2px -11px -1px -11px',
        padding: 0,
        borderWidth: '1.5px',
        borderStyle: 'solid',
        display: 'inline-block',
        borderRadius: '5px',
        width: 'calc(100% + 22px)',
        borderColor: 'transparent'
    },
    omitted: {
        display: 'contents' // don't affect styles & rendering if passed validation
    },
    validationErrorBorder: {
        borderColor: `${palette.validation.error} !important`
    },
    validationErrorLabel: {
        color: `${palette.validation.error} !important`,
        borderColor: `${palette.validation.error} !important`
    },
    validationSuggestedBorder: {
        borderColor: `${palette.validation.suggested} !important`
    },
    validationSuggestedLabel: {
        color: `${palette.validation.suggested} !important`,
        borderColor: `${palette.validation.suggested} !important`
    },
    validationOptionalBorder: {
        borderColor: `${palette.validation.optional} !important`
    },
    validationOptionalLabel: {
        color: `${palette.validation.optional} !important`,
        borderColor: `${palette.validation.optional} !important`
    },
    validationLabel: {
        lineHeight: '1 !important',
        fontSize: '12px !important',
        padding: '5px 15px 5px 15px',
        background: 'white',
        borderRadius: '0 0 5px 5px',
        borderTop: '1px dashed transparent'
    }
});

export default withStyles(styles)(ValidationPlaceholder);
